import React, { useRef } from 'react';
import {
  IonItemSliding,
  IonItem,
  IonLabel,
} from '@ionic/react';
import { Shipment } from '../models/Shipment';

interface ShipmentListItemProps {
  shipment: Shipment;
}

const ShipmentListItem: React.FC<ShipmentListItemProps> = ({
  shipment,
}) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);

  return (
    <IonItemSliding
      ref={ionItemSlidingRef}
      class={'track-' + shipment.jan.toLowerCase()}
    >
      <IonItem>
        <IonLabel>
          <h3 style={{ fontSize: '20px' }}>
            商品コード : {(shipment.jan !== "" && shipment.original_num !== "") ? `${shipment.jan} - ${shipment.original_num}` : shipment.jan + shipment.original_num}
          </h3>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            RACK NUM : {shipment.rack_num}, 
            数量 : {shipment.quantity}, 
            注文番号 : {shipment.order_num}, 
            {(shipment.order_status === 1) ? " 出庫完了" : ""}
          </p>
        </IonLabel>
      </IonItem>
    </IonItemSliding>
  );
};

export default React.memo(ShipmentListItem);
